import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { formatNumber } from '../../utils/generalFunctions';

import { buscarDashboard } from '../../actions/dashboard';

import MiniBarChart from '../../components/dashboard/MiniBarChart';

const DashboardAdministrador = () => {

    const dispatch =  useDispatch();

    const { detalles } = useSelector(state => state.dashboard);
    const { usuario } = useSelector(state => state.auth);

    const [dashboardData, setDashboardData] = useState({
        eventos_entradas_totales: null, 
        eventos_confirmaciones_totales: null, 
        eventos_entradas_hoy: null, 
        eventos_confirmaciones_hoy: null
    });

    useEffect(() => {
        dispatch(buscarDashboard('eventos'));
    }, []);

    useEffect(() => {
        if(detalles){
            setDashboardData({
                ...dashboardData, 
                eventos_entradas_totales: detalles.eventos_entradas_totales, 
                eventos_confirmaciones_totales: detalles.eventos_confirmaciones_totales, 
                eventos_entradas_hoy: detalles.eventos_entradas_hoy, 
                eventos_confirmaciones_hoy: detalles.eventos_confirmaciones_hoy
            });
        }        
    }, [detalles]);

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        .imagen_perfil {
                            height: 100px;
                            width: 100px;
                            border-radius: 50%;
                            border: 2px solid #111f62;
                            margin-right: 15px;
                        }

                        .titulo {
                            color: #111f62;
                        }

                        .indicador {
                            font-size: 18px;
                            margin: 0;
                        }

                        .subtitulo {
                            margin: 0;
                            font-weight: 700;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>
        
            <div className="col-md-12 d-flex align-items-center mb-2">
                <img className="imagen_perfil" src={usuario.url_perfil_g != null ? usuario.url_perfil_g : process.env.REACT_APP_PUBLIC_ROUTE + '/assets/images/perfil_placeholder.png'}/>
                <h4 className="titulo">
                    Bienvenido {[usuario.nombre, usuario.apellido_paterno, usuario.apellido_materno].join(' ')}
                </h4>
            </div>

            <div className="col-md-6 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Eventos</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.eventos_entradas_totales != null && dashboardData.eventos_entradas_totales != undefined ? formatNumber(dashboardData.eventos_entradas_totales, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">entradas totales</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.eventos_confirmaciones_totales != null && dashboardData.eventos_confirmaciones_totales != undefined ? formatNumber(dashboardData.eventos_confirmaciones_totales, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">confirmaciones totales</p>
                            </div>
                        </div>
                        {
                            detalles ?
                                <MiniBarChart datos={[
                                    { nombre: 'Entradas', valor: dashboardData.eventos_entradas_totales || 0 },
                                    { nombre: 'Confirmadas', valor: dashboardData.eventos_confirmaciones_totales || 0 }
                                ]} />
                            :
                                null
                        }
                    </div>
                </div>
            </div>

            <div className="col-md-6 mt-3">
                <div className="card bg-light">
                    <div className="card-body">
                        <div className="card-title mb-3">
                            <h5 className="titulo">Eventos de hoy</h5>
                        </div>
                        <div className="row mt-2">
                            <div className="col">
                                <p className="indicador">{dashboardData.eventos_entradas_hoy != null && dashboardData.eventos_entradas_hoy != undefined ? formatNumber(dashboardData.eventos_entradas_hoy, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">entradas</p>
                            </div>
                            <div className="col">
                                <p className="indicador">{dashboardData.eventos_confirmaciones_hoy != null && dashboardData.eventos_confirmaciones_hoy != undefined ? formatNumber(dashboardData.eventos_confirmaciones_hoy, 0, '', '') : 'Sin definir'}</p>
                                <p className="subtitulo">confirmaciones</p>
                            </div>
                        </div>
                        {
                            detalles ?
                                <MiniBarChart datos={[
                                    { nombre: 'Entradas', valor: dashboardData.eventos_entradas_hoy || 0 },
                                    { nombre: 'Confirmadas', valor: dashboardData.eventos_confirmaciones_hoy || 0 }
                                ]} />
                            :
                                null
                        }
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default DashboardAdministrador;